// 用于配置安卓平台物理按键的返回事件
var go = {
    goTo: function(self) {
        self.$root.eventBus.$emit("hideLoading")
        console.log("[当前访问:]", self.$route.name)
        if (self.$route.name == "item") {
            self.$router.push({
                name: "team"
            })
        }
        if (self.$route.name == "search") {
            self.$router.push({
                path: "/team/item"
            })
        }
        if (self.$route.name == "group") {
            self.$router.push({ name: "team" })
        }
        if (self.$route.name == "design") {
            self.$router.push({
                path: "/team/item"
            })
        }
        if (self.$route.name == "proto") {
            if (localStorage.backtoproto === "true") {
                
                self.$router.push({
                    name: "proto",
                    query: {
                        image_id: localStorage.lastProto
                    }
                })
            } else {
                self.$router.push({
                    name: "design",
                    query: {
                        image_id: self.$route.query.image_id
                    }
                })
            }
        }
        if (self.$route.name == "info") {
            if (localStorage.bann == "") {
                self.$router.push({
                    name: "team"
                })
            }
            return
        }
        if (self.$route.name == "kefu") {
            self.$router.push({
                name: "info"
            })
        }
        if (self.$route.name == "comment") {
            if (localStorage.pageReply === "true") {
                self.$emit("close_reply")
            }
            self.$router.push({
                name: "design",
                query: {
                    project_id: self.$route.query.project_id,
                    project_name: self.$route.query.project_name,
                    image_id: self.$route.query.image_id
                }
            })
        }
        return
    }
}

export default go
